export enum FrageHaeufigkeitNachteinsaetze {
  EINMALPRONACHT = 'einmalpronacht',

  ZWEIMALPRONACHT = 'zweimalpronacht',

  DREIMALPRONACHT = 'dreimalpronacht',
}
